import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  me:{},
  producerId:null,
  isMeetingStart:false,
  isMute:false,
  isVideoTrack:true,
  meetId:''
};

export const videoMeetingSlice = createSlice({
  name: "videoMeeting",
  initialState,
  reducers: {
    updateMe: (state, action) => {
      return { ...state, me: action.payload };
    },
    updateProducerId: (state, action) => {
      return { ...state, producerId: action.payload };
    },
    updateMeetId:(state, action) => {
      return { ...state, meetId: action.payload };
    }
  },
});
export const { updateMe, updateProducerId,updateMeetId } = videoMeetingSlice.actions;

export default videoMeetingSlice.reducer;

